<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M18.06 13.56l4.44-4.44V32.5a1.5 1.5 0 003 0V9.12l4.44 4.44a1.51 1.51 0 002.12 0 1.49 1.49 0 000-2.11l-7-7a1.63 1.63 0 00-.49-.33 1.4 1.4 0 00-1.1 0 1.63 1.63 0 00-.49.33l-7 7a1.5 1.5 0 002.12 2.12z"/><path d="M30.21 26.43a1.51 1.51 0 10-.42 3C37.07 30.41 41 33 41 35c0 2.51-6.47 6-17 6S7 37.51 7 35c0-2 3.93-4.59 11.21-5.6a1.51 1.51 0 10-.42-3C9.29 27.61 4 30.89 4 35c0 5.85 10.3 9 20 9s20-3.15 20-9c0-4.11-5.29-7.39-13.79-8.57z"/></svg>